import React from 'react';

type Props = {
  testID?: string;
  active?: boolean;
};

export const StepTail: React.FC<Props> = ({ active, testID = 'StepTail' }) => {
  const activeClasses = active ? 'bg-dark' : 'bg-gray-600';
  return <hr style={{ width: '100px' }} className={`fill-current ${activeClasses}`} />;
};
